import styled from "styled-components"

export default styled.div`
    &{
        width: 100%;
        height: 100%;
    }

    .go-back{
        margin-top: 20px;
        margin-bottom: 20px;
    }

    #title{
        display: flex;
        justify-content: space-between;
        vertical-align: middle;
        text-align: center;
        align-content: center;
        gap: ${props => props.theme.spacing.spacing_04};
        margin-bottom: ${props => props.theme.spacing.spacing_04};
    }

    h4{
        display:flex;
        align-items: center;
        justify-content: center;
    }

    td, th{
        vertical-align: middle !important;
        border-left: none;
    }

    tbody tr{
        border-left: none;
        cursor: pointer;
    }
    
    .payment-dates {
        display: flex;
        flex-wrap: wrap;
        max-width: 290px;
        gap: 1px;
    }

    .btn-date {
        width: 40px;
    }
`